import Keycloak from "keycloak-js";
export const isKeycloakEnabled = process.env.REACT_APP_KC_ENABLED === "true";

const getKeycloakConfig = () => {
    const url = process.env.REACT_APP_KEYCLOAK_SERVER_URL;
    const realm = process.env.REACT_APP_KEYCLOAK_REALM;
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT;

    if (!url || !realm || !clientId) {
        console.error("Configuration Keycloak manquante");
        throw new Error("Variables d'environnement Keycloak manquantes");
    }

    return { url, realm, clientId };
};

export const keycloak = isKeycloakEnabled
    ? new Keycloak(getKeycloakConfig())
    : null;
